import { PositiveYouCard } from "src/Views/PositiveYou/Components/PositiveYouCard/PositiveYouCard";
import { PositiveYouCard as PositiveYouHomeCard } from "src/Views/Home/components/PositiveYouCard/PositiveYouCard";
import { useState } from "react";
import Stepper from "shared/UI/Stepper/Stepper";
import { EntrySummaryCard } from "src/Views/PositiveYou/Components/EntrySummaryCard/EntrySummaryCard";
import { CalendarTheme } from "shared/UI/DatePicker/enum";
import InputDatePicker from "shared/UI/DatePicker/InputDatePicker/InputDatePicker";
import { CalendarDatePicker } from "shared/UI/DatePicker/CalendarDatePicker/CalendarDatePicker";
import { Container } from "shared/UI/LayoutComponents/LayoutComponents";
import Button from "shared/UI/Buttons/Button";
import { MoodActionType } from "shared/request/myHealthyAdvantageApi";
import { MoodJourneyPageModal, MoodJourneyModalTypes } from "../../Home/components/MoodJourneyPageModal/MoodPageModal";

export default function ComponentsPositiveYou() {
  const [maxItems, setMaxItems] = useState(4);
  const [stepSelected, setStepSelected] = useState(0);
  const [variant, setVariant] = useState<"primary" | "secondary">("primary");
  const [date, setDate] = useState<Date>();
  const [selectedMood, setSelectedMood] = useState<MoodJourneyModalTypes | null>(null);

  const handleMaxItemsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMaxItems(Number(e.target.value));
  };

  const handleSetDate = (date: Date) => {
    setDate(date);
  };

  const handleOpenMoodModal = (mood: MoodJourneyModalTypes) => {
    setSelectedMood(mood);
  };

  const handleCloseMoodModal = () => {
    setSelectedMood(null);
  };

  if (selectedMood) {
    return <MoodJourneyPageModal mood={selectedMood} visible handleClose={handleCloseMoodModal} onContinue={handleCloseMoodModal} />;
  }

  return (
    <Container>
      <div className="w-full mx-auto max-w-[400px] space-y-16">
        <Button text="Low" onClick={() => handleOpenMoodModal(MoodActionType.LowPositiveYouPrompt)} />
        <Button text="Neutral" onClick={() => handleOpenMoodModal(MoodActionType.MidPositiveYouPrompt)} />
        <Button text="High" onClick={() => handleOpenMoodModal(MoodActionType.GoodPositiveYouPrompt)} />
        <CalendarDatePicker
          minDate={new Date("2026-02-02")}
          maxDate={new Date("2026-06-10")}
          theme={CalendarTheme.Secondary}
          highlightDates={[new Date("2026-04-01"), new Date("2026-04-04"), new Date("2026-04-07")]}
          date={date}
          setDate={handleSetDate}
        />
        <InputDatePicker date={date} setDate={handleSetDate} />
        <p>Selected date: {date?.toString()}</p>
        <PositiveYouCard />
        <PositiveYouHomeCard />
        <div className="space-y-4">
          <Stepper theme={variant} steps={maxItems} activeStep={stepSelected} onSelect={(i) => setStepSelected(i)} />
          <input type="number" min={1} defaultValue={4} onChange={handleMaxItemsChange} className="border px-2 py-1 rounded" />
          <div className="flex flex-col gap-4">
            <button onClick={() => setVariant("primary")}>Primary variant</button>
            <button onClick={() => setVariant("secondary")}>Secondary variant</button>
          </div>
        </div>
        <EntrySummaryCard
          date="2026-03-31"
          content="I took my friend some flowers and a book when they were sick, I took my friend some flowers and a book when they were sick, 
        I took my friend some flowers and a book when they were sick!"
          attributes={[
            { id: "1", key: "Caring" },
            { id: "3", key: "Exhausted" },
            { id: "4", key: "Hopeful" },
            { id: "2", key: "Hardworking" },
          ]}
          onClick={() => {}}
        />
      </div>
    </Container>
  );
}
